/**
 * ImageHeader
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { Cell, Grid } from 'ui-component-library/base';
/** Main description for this component. */
var ImageHeader = function (_a) {
    var src = _a.src, alt = _a.alt, className = _a.className, figCaption = _a.figCaption, htmlAttributes = __rest(_a, ["src", "alt", "className", "figCaption"]);
    return (React.createElement("figure", __assign({ "data-cid": "ImageHeader", className: clsx(className, 'mb-4, lg:relative') }, htmlAttributes),
        React.createElement("img", { src: src, alt: alt, className: clsx('w-full h-32 md:h-64 lg:h-112 image__object-fit') }),
        figCaption && (React.createElement("figcaption", { className: clsx('p-0', 'text-p', 'lg:absolute', 'bottom-0', 'text-image-header-text-color', 'w-full', 'bg-transparent', 'z-10') },
            React.createElement(Grid, { className: "lg:px-6 -ml-4", padding: false, margin: false },
                React.createElement(Cell, { className: clsx('imageheader__figcaption', 'font-fontStandard w-full lg:w-6/12 ml-4 px-4 py-2 lg:pl-0 lg:pr-3') },
                    React.createElement("span", null, figCaption)))))));
};
export default ImageHeader;
